import { ContestType, CONTEST_TYPE_PRO } from "interfaces/leaderboard/contest";
import styles from "./contest-image.module.scss";

interface Props {
  url: string | undefined;
  type?: ContestType;
}
const ContestImage = ({ url, type }: Props) => {
  const defaultImage =
    "https://ad-images.s3.us-west-2.amazonaws.com/contest_logos/SPARKET-LOGO-tag-horizontal-head+(1).png";
  return (
    <div className={styles.wrapper}>
      <img className={styles.image} src={url || defaultImage} alt="" />
      {type === CONTEST_TYPE_PRO && (
        <span className={styles.typeTag}>Pro</span>
      )}
    </div>
  );
};

export default ContestImage;
